import React from 'react';
import PropTypes from 'prop-types';
import { Utils } from 'versafleet-core';
import ReduxActions from 'reduxActions';
import { connect } from 'react-redux';
import Logo from './logo';

class Authentication extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      form: {},
    };
  }

  UNSAFE_componentWillMount() {
    // The initial check does not require any error to be displayed,
    // therefore the catch block is only there to prevent unhandled promises
    this.props.dispatch(ReduxActions.profile.check())
      .catch(() => {});
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.isChecked && !Utils.Helper.isNullOrUndefined(nextProps.profile)) {
      Utils.Router.transitionTo('/home');
    }
  }

  _onFormChange(fieldName, value) {
    this.setState(prevState => ({
      form: {
        ...prevState.form,
        [fieldName]: value,
      },
    }));
  }

  render() {
    return this.props.isChecked ? (
      <div className="vf-authentication">

        <div className="vf-authentication__container">
          <Logo />
          {this.props.children}
        </div>

        <img alt="truck" className="vf-authentication__truck" src="/assets/images/versafleet_RushingTruck.png" />

      </div>
    ) : false;
  }
}

Authentication.displayName = 'Authentication';

Authentication.propTypes = {
  children: PropTypes.node,
  dispatch: PropTypes.func.isRequired,
  isChecked: PropTypes.bool.isRequired,
  profile: PropTypes.shape({}),
};

Authentication.defaultProps = {
  children: null,
  profile: {},
};

function mapStateToProps(state) {
  const { profile } = state;

  return {
    profile: profile.profile,
    isChecked: profile.isChecked,
  };
}

export default connect(mapStateToProps)(Authentication);
